import {safeMeta} from "@/router/Meta";
import {TRADE_CONTRACT_STATUSES} from "@/constants";
import {Location} from "vue-router";
import TradeContractView from "@/components/pages/contract/TradeContract/TradeContractView";
import {defineComponent} from "vue";

/**
 * TradeContract 生成の為のデータソース
 */
export default defineComponent({
  name: 'TradeContractUtils',
  methods: {
    /**
     * 指定された取引契約に合った戻り画面遷移先を取得します
     *
     * @param tradeContract 取引契約ビュー
     */
    backToLocation(tradeContract: TradeContractView): Location {
      if(this.$route.query.from === 'public') {
        return {
          ...this.statusToLocation('public'),
          query: {
            selection: tradeContract.baseId
          }
        };
      }

      let location = this.statusToLocation(tradeContract.status);
      if(tradeContract.status === 'public') {
        if(tradeContract.amiIssuer) {
          location.query = {
            selection: tradeContract.id
          };
        } else {
          location = {name: '/profileSearch/publicTradeContracts'};
        }
      }
      return location;
    },

    /**
     * 指定された取引契約ステータスから次の画面遷移先を取得します
     *
     * @param status 取引契約ステータス
     */
    statusToLocation(status: keyof typeof TRADE_CONTRACT_STATUSES): Location {
      switch(status) {
        // 契約成立前
        case 'preparing':
        case 'requesting':
        case 'applying':
        case 'revising':
          return {name: '/edit/tradeContract/list/pretrading'};
        // 募集
        case 'public':
          return {name: '/edit/tradeContract/list/public'};
        // 契約成立後
        case 'trading':
          return {name: '/edit/tradeContract/list/trading'};
        // 停止・終了系
        case 'private':
          return {name: '/edit/tradeContract/list/suspended'};
        case 'suspended':
          return {name: '/edit/tradeContract/list/suspended'};
        case 'rejected':
          return {name: '/edit/tradeContract/list/pretrading'};
        default:
          return {name: safeMeta(this.$route).parent};
      }
    },

    /**
     * 編集ページの画面遷移先を取得します
     *
     * @param tradeContract 取引契約ビュー
     */
    editLocation(tradeContract: TradeContractView): Location {
      const routeTo = (() => {
        if(tradeContract.isRequestDraftMode) {
          return tradeContract.amiRecipient ? '/adaptContract' : '/draftContract';
        } else if(tradeContract.isRequestOfferMode) {
          return tradeContract.amiRecipient ? '/applyContract' : '/offerContract';
        } else if(tradeContract.isPublishMode) {
          return '/publishContract';
        } else if(tradeContract.isSubscribeMode) {
          return tradeContract.amiRecipient ? '/applyContract' : '/subscribeContract';
        } else {
          throw new Error();
        }
      })();

      return {
        name: routeTo,
        params: {tradeContractId: tradeContract.id}
      };
    },
  }
});
